import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React from 'react'

import EventBlocker from 'components/common/EventBlocker'

import UpcomingWorkOrdersDialog from './UpcomingWorkOrdersDialog'
import UpcomingWorkOrdersPopover from './UpcomingWorkOrdersPopover'

const UpcomingWorkOrdersLayout = ({
  isLoading = false,
  anchorEl,
  isOpenDialog = false,
  serviceType,
  workOrders = [],
  onClosePopover = noop,
  onCloseDialog = noop,
  popoverProps = {},
  dialogProps = {},
}) => {
  return (
    <>
      <UpcomingWorkOrdersPopover
        anchorEl={anchorEl}
        isLoading={isLoading}
        serviceType={serviceType}
        workOrders={workOrders}
        onClose={onClosePopover}
        {...popoverProps}
      />
      <EventBlocker preventDefault={false}>
        <UpcomingWorkOrdersDialog
          isOpen={isOpenDialog}
          serviceType={serviceType}
          workOrders={workOrders}
          onClose={onCloseDialog}
          {...dialogProps}
        />
      </EventBlocker>
    </>
  )
}

UpcomingWorkOrdersLayout.propTypes = {
  isLoading: PropTypes.bool,
  anchorEl: PropTypes.object,
  isOpenDialog: PropTypes.bool,
  serviceType: PropTypes.string.isRequired,
  workOrders: PropTypes.array,
  onClosePopover: PropTypes.func,
  onCloseDialog: PropTypes.func,
  popoverProps: PropTypes.object,
  dialogProps: PropTypes.object,
}

export default UpcomingWorkOrdersLayout
